<template>
  <cos-modal
    v-model:visible="visible"
    title="变更标签"
    width="900px"
    class="addModel"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :model="dataForm" ref="formRef" class="launchTable">
      <cos-table
        :columns="columns"
        :dataSource="dataForm.customerLabelList"
        :needPage="false"
        rowKey="cosId"
        :loading="loading"
        tableId="customerLabelList"
      >
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.dataIndex === 'cosId'">
            <a-form-item :name="['customerLabelList', index, 'cosId']" :rules="[{ required: true, message: '请选择客户' }]">
              <ClueAndCustomerSelect appId="cos_lbu" v-model:value="record.cosId" v-model:record="customerRecord" placeholder="请选择客户名称" allowClear />
            </a-form-item>
          </template>
          <template v-if="column.dataIndex === 'labelIdList'">
            <a-form-item :field="`customerLabelList[${index}].labelIdList`"  :rules="[{ required: true, message: '请选择标签' }]">
              <CustomerLabelCascader type="search" appId="cos_lbu" :onlyCommon=false v-model:ids="record.labelIdList" />
              <!-- <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="record.labelIdList" /> :name="['customerLabelList', index, 'labelIdList']"  -->
            </a-form-item>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a-button type="link" @click="onDelete(index)"> 删除 </a-button>
          </template>
        </template>
      </cos-table>
      <a-button type="primary" ghost @click="onAdd()">新增</a-button>
    </a-form>
  </cos-modal>
</template>
<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import { batchSaveCustomerLabel } from '@/api/yuntuSales/customerLabelManage'
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const dataForm = ref({ customerLabelList: [{ cosId: undefined, labelIdList: [], appId: 'cos_lbu' }] })
const customerRecord = ref<any>({})

watch(
  () => visible.value,
  (val) => {
    if (!val) {
      formRef.value?.resetFields()
      dataForm.value.customerLabelList = [{ cosId: undefined, labelIdList: [], appId: 'cos_lbu' }]
    }
  }
)

watch(
  () => customerRecord.value,
  (val) => {
    const customerLabelList = dataForm.value.customerLabelList
    const i = customerLabelList.find((item: any) => item.cosId === val.id)
    if (i) {
      i.labelIdList = val.labelIdList
      // console.log('Changed:', customerLabelList, dataForm.value.customerLabelList)
      // dataForm.value.customerLabelList = customerLabelList
      // dataForm.value = {
      //   customerLabelList: customerLabelList
      // }
    }
  },
  { immediate: true }
)

const onDelete = (index: number) => {
  dataForm.value.customerLabelList.splice(index, 1)
}

const onAdd = () => {
  dataForm.value.customerLabelList.push({ cosId: undefined, labelIdList: [], appId: 'cos_lbu' })
}

const init = () => {
  visible.value = true
}

const columns = computed(() => [
  { title: '客户名称', dataIndex: 'cosId' },
  { title: '标签', dataIndex: 'labelIdList' },
  { title: '操作', dataIndex: 'action', width: 50 }
])

const emit = defineEmits(['fetch'])
const handleOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    const params = Object.assign({}, dataForm.value)
    batchSaveCustomerLabel(params)
      .then(() => {
        DcMessage.success('变更标签成功')
        formRef.value?.resetFields()
        visible.value = false
        emit('fetch')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'CustomerLabelAddModel' }
</script>

<style lang="scss" scoped>
.addModel {
  .list {
    margin: 10px 0;
    li {
      display: flex;
      align-items: center;
    }
    .name {
      flex: 1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.flex1 {
  flex: 1;
}
.launchTable {
  :deep(.ant-table .ant-form-item.ant-form-item-has-error) {
    margin-bottom: 0;
  }
  :deep(.ant-form-item-explain-error) {
    display: none;
  }
}
</style>
